import { lazy } from "react";

const CandidateCalendar = lazy(
  () => import("../app/features/candidate-management/pages/candidate-calendar-page")
);
const CandidateListing = lazy(() => import("../app/features/candidate-management"));
const DailyBooking = lazy(() => import("../app/features/booking/pages/daily-booking-page"));
const CandidateProfile = lazy(
  () => import("../app/features/candidate-management/pages/candidate-profile-page")
);
const SiteListing = lazy(() => import("../app/features/site-management"));
const SiteProfile = lazy(() => import("../app/features/site-management/pages/site-profile-page"));
const BookingCalendar = lazy(() => import("../app/features/booking/pages/monthly-booking-page"));
const WeeklyCalendar = lazy(() => import("../app/features/booking/pages/weekly-booking-page"));
const UserManagement = lazy(() => import("../app/features/user-management"));
const GeneratePayrate = lazy(() => import("../app/features/generate-pay-document"));
const FinanceHoliday = lazy(() => import("../app/features/holiday"));
const Document = lazy(() => import("../app/features/documents"));
const CostAnalysis = lazy(() => import("../app/features/reports/pages/cost-analysis-page"));
const Infringement = lazy(() => import("../app/features/reports/pages/infringement-page"));
const CandidatePerformance = lazy(
  () => import("../app/features/reports/pages/candidate-performance-page")
);
const SystemSetup = lazy(() => import("../app/features/system-setup"));
const PayRateListing = lazy(() => import("../app/features/manage-pay-rates"));
const GeneratePayRate = lazy(
  () => import("../app/features/site-management/ui/site-profile/general-details")
);
const VerifyBooking = lazy(() => import("../app/features/verify-booking"));
const Sts = lazy(() => import("../app/features/sts"));
const ClientManagement = lazy(() => import("../app/features/client-management"));
const Reports = lazy(() => import("../app/features/reports"));

export {
  CandidateListing,
  CandidateProfile,
  CandidateCalendar,
  SiteListing,
  SiteProfile,
  DailyBooking,
  BookingCalendar,
  WeeklyCalendar,
  UserManagement,
  GeneratePayrate,
  Document,
  CostAnalysis,
  Infringement,
  CandidatePerformance,
  SystemSetup,
  PayRateListing,
  GeneratePayRate,
  VerifyBooking,
  Sts,
  ClientManagement,
  Reports,
  FinanceHoliday
};
